var $1e422c6caf1d6300$exports = {};
$1e422c6caf1d6300$exports = {
    "clear": `Borrar`,
    "invalid": `(no v\xe1lido)`,
    "loading": `Cargando\u{2026}`,
    "noResults": `Sin resultados`
};


export {$1e422c6caf1d6300$exports as default};
//# sourceMappingURL=es-ES.module.js.map
